import React, { Component } from 'react';
import { Box, Fab, Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import { DEFAULT_ADMIN_PAGES, DEFAULT_SUPER_ADMIN_PAGES, PAGES, ROLES } from '../AccessTypeForm';
import { EditRounded } from '@mui/icons-material';
import TitleWithEndAction from '../../../common/TitleWithEndAction';


// isUserPlus = user.user_role === 10
// isAdmin = user.user_role > 1
// isSuperAdmin = user.user_role > 2 && user.user_role !== 10


// else {
//     menuList.push(
//         ADMIN_MENU["dashboard"],
//         ADMIN_MENU["users"],
//         ADMIN_MENU["spendings"],
//         ADMIN_MENU["categories"],
//         ADMIN_MENU["suppliers"],
//         ADMIN_MENU["labels"],
//         ADMIN_MENU["banks"],
//         ADMIN_MENU["payments"],
//         ADMIN_MENU["advances"],
//         ADMIN_MENU["credits"],
//         ADMIN_MENU["projects"],
//         ADMIN_MENU["chantiers"],
//         ADMIN_MENU["factures"],
//         ADMIN_MENU["incomes"],
//         ADMIN_MENU["transfers"],
//     )
        
//     this.props.isSuper && menuList.push(
//         ADMIN_MENU["schedule"],
//         ADMIN_MENU["extracts"],
//         ADMIN_MENU["equipements"],
//         // ADMIN_MENU["imports"],
//         ADMIN_MENU["salary"],
//         ADMIN_MENU["budget"],
//         ADMIN_MENU["demands"],
//         ADMIN_MENU["society"],
//     )
// }
class UserInfo extends Component {
    render() {
        const { user, ACCESS} = this.props;
        const organizationName = user?.user_organization_name || "Non renseigné";
        console.log('=============PROPS======USER=================');
        console.log(this.props.user);
        console.log('====================================');
        return (
            <Box>
                <TitleWithEndAction
                    title={" "}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.props.handleOpenUpdate()} 
                        title="Modifier"
                        size="small"
                    >
                        <EditRounded />
                    </Fab>
                </TitleWithEndAction>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        
                        <List>
                            <ListItem>
                                <ListItemText 
                                    primary={
                                        <Typography color="textSecondary" variant="body2">Nom</Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">
                                            {`${user.username} ${user.lastname.toUpperCase()}`}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={
                                        <Typography color="textSecondary" variant="body2">Organisation</Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">
                                            {organizationName}
                                        </Typography>
                                    } 
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary={
                                    <Typography color="textSecondary" variant="body2">Email</Typography>
                                }
                                secondary={
                                    <Typography variant="body1">
                                        {user.email}
                                    </Typography>
                                } />
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={
                                        <Typography color="textSecondary" variant="body2">Role</Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">
                                            {ROLES[user.user_role]}
                                        </Typography>
                                    } 
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={
                                        <Typography color="textSecondary" variant="body2">Statut Compte</Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">
                                            {
                                                user.user_status === "DELETED" ? "SUPPRIMÉ"
                                                : user.user_status === "WAITING_ACTIVATION" ? "En attente confirmation"
                                                : user.user_status === "BLOCKED" ? "BLOCKED"
                                                : !user.user_is_active ? "DÉSACTIVÉ"
                                                : user.user_status
                                            }
                                        </Typography>
                                    }
                                />
                            </ListItem>
                       
                                {/* <ListItem>
                                    <ListItemText 
                                        primary={
                                            <Typography color="textSecondary" variant="body2">Super Email</Typography>
                                        }
                                        secondary={
                                            <Typography variant="body1">
                                                {user.user_super_email}
                                            </Typography>
                                        } 
                                    />
                                </ListItem> */}
                            
                        </List>
                    </Grid>
                    {user.user_role > 1 &&
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">L'utilisateur a accès aux pages suivantes : </Typography>
                            {user.user_type ?
                                <>
                                    <Typography variant="h5" color="primary">{ACCESS[user.user_type].access_name}</Typography>
                                    <List>
                                        
                                        {/* {!ACCESS[user.user_type].access_pages.includes("dashboard")  &&
                                            <Typography variant="button" >Dashboard</Typography>
                                        } */}
                                        {ACCESS[user.user_type].access_pages.map( page => (
                                            <ListItem><ListItemText inset primary={<Typography variant="button">{PAGES[page]}</Typography>} /></ListItem>
                                        ))}
                                    </List>
                                </>
                                :
                                <List>
                                    {DEFAULT_ADMIN_PAGES.map( page => (
                                        <ListItem><ListItemText inset primary={<Typography variant="button">{PAGES[page]}</Typography>} /></ListItem>
                                    ))}
                                    
                                    {user.user_role > 2 && user.user_role !== 10 && DEFAULT_SUPER_ADMIN_PAGES.map( page => (
                                        <ListItem><ListItemText inset primary={<Typography variant="button">{PAGES[page]}</Typography>} /></ListItem>
                                    ))}
                                </List>
                                
                                    
                            }
                        </Grid>
                    }
                </Grid>
            </Box>
        );
    }
}

export default UserInfo;